import { DefaultButton } from "@fluentui/react/lib/Button";
import { Stack } from "@fluentui/react/lib/Stack";

import { clearLocalStorage } from "API/LocalStorage";
import { IWithTranslatorProps, WithTranslator } from "Components/Generic/Translator";
import { useCallback } from "react";

export const CacheData = WithTranslator((props: IWithTranslatorProps): JSX.Element => {
  const { translator } = props;
  const onClick = useCallback(() => clearLocalStorage(), []);

  return (
    <Stack horizontal grow horizontalAlign="end">
      <Stack.Item grow={false}>
        <DefaultButton onClick={onClick}>
          {translator.get(`settings.cache.delete`, `Delete Cache`)}
        </DefaultButton>
      </Stack.Item>
    </Stack>
  );
});
